export default class OfficeModel extends Backbone.Model {
  constructor (...args) {
    super(...args)
    this.initialize = this.initialize.bind(this)
    this.isEditing = this.isEditing.bind(this)
    this.isPresenting = this.isPresenting.bind(this)
    this.isVisible = this.isVisible.bind(this)
    this.toJSON = this.toJSON.bind(this)
  }

  get persistedAttributes () {
    return this._persistedAttributes || ['url']
  }

  set persistedAttributes (attrs) {
    this._persistedAttributes = attrs
  }

  // TODO
  // - Figure out of I can simply grab all of the k/v pairs from
  //   the hosted PPT application so that we don"t need to maintain
  //   a whitelist of attributes.
  get defaults () {
    return {
      url: '', // Root url of the router
      activeView: 'read',
      visibility: 'hidden'
    }
  }

  initialize (attributes, options) {
    // The reactor will provide the sync method
    this.sync = options.sync

    // If a slide remains 'visible' at the end of a presentation, and the next presentation
    // starts with a different slide, they compete for activation since they both think they
    // are visible. To get around this we mark slides as 'hidden' when presentation ends.
    this.listenTo(this, 'change:activeView', () => {
      if (this.isEditing()) {
        this.set('visibility', 'hidden')
      }
    })
  }

  // End user is editing the PowerPoint slide.
  isEditing () {
    return this.get('activeView') === 'edit'
  }

  // End user is presenting the PowerPoint slide.
  isPresenting () {
    return this.get('activeView') === 'read'
  }

  isVisible () {
    return this.get('visibility') === 'visible'
  }

  toJSON () {
    return this.pick(this.persistedAttributes)
  }

  saveActivity (type, permalink) {
    const newUrl = `${type}/${permalink}`
    if (this.get('url') !== newUrl) {
      console.log(`saving activity ${newUrl} to slide`)
      this.save({
        url: `${type}/${permalink}`
      })
    } else {
      console.log('skipping duplicate activity save to slide')
    }
  }

  clearActivity () {
    console.log('clearing activity from slide')
    this.save({})
  }

  // Base Model includes the CORS mixin that has a Sync method.
  // That mixin trumps all defined methods in this class so we
  // override the mixin methods after its included.
  url () {
    return typeof console !== 'undefined' && console !== null
      ? console.error(
        'Backbone.Model.url method disabled for PollEv.Model.Office',
        arguments
      )
      : undefined
  }
  // No need for a URL

  // Provide error in case sync isn't passed in
  // Sync in this case will be syncing to the presentation rather than a server
  sync () {
    return typeof console !== 'undefined' && console !== null
      ? console.error(
        'Model.Office: The sync method should be passed in as an option'
      )
      : undefined
  }
}
